/** Phase 7D — SCR-BIZ-013–019 policies and approvals bindings (07-02) */

export const POLICIES_APPROVALS_SCREEN_IDS = [
  'SCR-BIZ-013',
  'SCR-BIZ-014',
  'SCR-BIZ-015',
  'SCR-BIZ-016',
  'SCR-BIZ-017',
  'SCR-BIZ-018',
  'SCR-BIZ-019',
] as const;

export type PoliciesApprovalsScreenId = (typeof POLICIES_APPROVALS_SCREEN_IDS)[number];

export const POLICIES_APPROVALS_ROUTES: Record<PoliciesApprovalsScreenId, string> = {
  'SCR-BIZ-013': '/policy-list',
  'SCR-BIZ-014': '/policy-editor',
  'SCR-BIZ-015': '/policy-simulator',
  'SCR-BIZ-016': '/approval-chain',
  'SCR-BIZ-017': '/delegation-settings',
  'SCR-BIZ-018': '/approval-queue',
  'SCR-BIZ-019': '/approval-detail',
};

/** Canonical 07-03 URL. `/approval-detail` remains as a legacy fallback. */
export const APPROVAL_DETAIL_CANONICAL_PATH = '/approvals/:id';

export const POLICIES_APPROVALS_PERMISSIONS: Partial<
  Record<PoliciesApprovalsScreenId, readonly string[]>
> = {
  'SCR-BIZ-013': ['PERM-corporate.policy.read'],
  'SCR-BIZ-014': ['PERM-corporate.policy.update'],
  'SCR-BIZ-015': ['PERM-corporate.policy.read'],
  'SCR-BIZ-016': ['PERM-approval.chain.update'],
  'SCR-BIZ-017': ['PERM-approval.delegation.create'],
  'SCR-BIZ-018': ['PERM-approval.request.decide'],
  'SCR-BIZ-019': ['PERM-approval.request.decide'],
};

export const POLICIES_APPROVALS_ENDPOINTS: Partial<
  Record<PoliciesApprovalsScreenId, readonly string[]>
> = {
  'SCR-BIZ-013': ['GET /business/v1/policies'],
  'SCR-BIZ-014': [
    'POST /business/v1/policies',
    'PATCH /business/v1/policies/{id}',
    'GET /business/v1/policies/{id}/versions',
    'POST /business/v1/policies/{id}/revert',
  ],
  'SCR-BIZ-015': ['POST /business/v1/policies/{id}/simulate'],
  'SCR-BIZ-016': [
    'GET /business/v1/approval-chains',
    'POST /business/v1/approval-chains',
    'PATCH /business/v1/approval-chains/{id}',
  ],
  'SCR-BIZ-017': [
    'GET /business/v1/approval-delegations',
    'POST /business/v1/approval-delegations',
    'DELETE /business/v1/approval-delegations/{id}',
  ],
  'SCR-BIZ-018': ['GET /business/v1/approvals', 'POST /business/v1/realtime/connection-tickets'],
  'SCR-BIZ-019': [
    'GET /business/v1/approvals/{id}',
    'POST /business/v1/approvals/{id}/approve',
    'POST /business/v1/approvals/{id}/reject',
    'POST /business/v1/approvals/{id}/question',
    'POST /business/v1/approvals/{id}/withdraw',
    'POST /business/v1/realtime/connection-tickets',
  ],
};

export const POLICY_ID_STORAGE_KEY = 'beatq.business.policyId';
export const APPROVAL_ID_STORAGE_KEY = 'beatq.business.approvalId';
